import {ContentMessageType} from "../models/chat";

/**
 * Parses a media type string into a ContentMessageType enum value
 * @param mediaType - The MIME type string (e.g., "image/png", "video/mp4")
 * @returns The corresponding ContentMessageType enum value
 */
export function parseMediaTypeToContentType(mediaType: string): ContentMessageType {
  if (!mediaType) {
    return ContentMessageType.Unsupported;
  }

  // Convert to lowercase for case-insensitive comparison
  const lowerMediaType = mediaType.toLowerCase();

  // Check primary type (first part of MIME type)
  if (lowerMediaType.startsWith('text/')) {
    return ContentMessageType.Text;
  } else if (lowerMediaType.startsWith('image/')) {
    return ContentMessageType.Image;
  } else if (lowerMediaType.startsWith('video/')) {
    return ContentMessageType.Video;
  } else if (lowerMediaType.startsWith('audio/')) {
    return ContentMessageType.Audio;
  } else if (
    // Common document types
    lowerMediaType.startsWith('application/pdf') ||
    lowerMediaType.startsWith('application/msword') ||
    lowerMediaType.startsWith('application/vnd.openxmlformats-officedocument.wordprocessingml.document') || // .docx
    lowerMediaType.startsWith('application/vnd.ms-excel') ||
    lowerMediaType.startsWith('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || // .xlsx
    lowerMediaType.startsWith('application/vnd.ms-powerpoint') ||
    lowerMediaType.startsWith('application/vnd.openxmlformats-officedocument.presentationml.presentation') || // .pptx
    lowerMediaType.startsWith('application/rtf') ||
    lowerMediaType.startsWith('application/vnd.oasis.opendocument')
  ) {
    return ContentMessageType.Document;
  }

  return ContentMessageType.Unsupported;
}

// Example usage:
// const contentType = parseMediaTypeToContentType('image/png'); // Returns ContentMessageType.Image
